import axios, { all } from "axios";

class Connection {
    HEADERS = null;
    baseURL = "https://api.kharazienika.ir";
    //baseURL = "https://servertest.kharazienika.ir";
    // KCbaseURL = "https://37.156.145.155:2500";
    //baseURL = "http://localhost:2500";
    _axios = axios.create({ baseURL: this.baseURL });

    setCreds(un, token) {
        this.HEADERS = new axios.AxiosHeaders().setAuthorization(
            JSON.stringify({ un, token, admin: true })
        );
        this._axios.defaults.headers = this.HEADERS;
    }

    login(un, password) {
        return new Promise((resolve, reject) => {
            this._axios
                .post("/users/login", { un, password, admin: true })
                .then((res) => {
                    let { un, token } = res.data;
                    this.setCreds(un, token);
                    resolve(res);
                })
                .catch(reject);
        });
    }

    validateToken(un, token) {
        return new Promise((resolve, reject) => {
            let headers = new axios.AxiosHeaders().setAuthorization(
                JSON.stringify({ un, token, admin: true })
            );
            this._axios
                .get("/users/validateToken", {
                    headers,
                })
                .then((res) => {
                    this.setCreds(un, token);
                    resolve(res);
                })
                .catch((err) => {
                    this.HEADERS = null;
                    reject(err);
                });
        });
    }

    subscribe_notifications(subscription) {
        return new Promise((resolve, reject) => {
            this._axios
                .post("/users/subscribeNotifs", subscription)
                .then(resolve)
                .catch(reject);
        });
    }
    unsubscribe_notifications() {
        return new Promise((resolve, reject) => {
            this._axios
                .delete("/users/subscribeNotifs")
                .then(resolve)
                .catch(reject);
        });
    }

    is_notifications_subscribed(subscription) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/users/subscribeNotifs", subscription)
                .then(resolve)
                .catch(reject);
        });
    }

    get_all_special_offers() {
        return this.get_filtered_data({ is_special_offer: true });
    }

    get_best_sellers(count) {
        return this.get_filtered_data(null, "sold_count", count);
    }

    get_all_suggestions() {
        return new Promise((resolve, reject) => {
            this._axios
                .get("items?is_suggestion=true")
                .then(resolve)
                .catch(reject);
        });
    }

    get_item(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("items/" + id)
                .then(resolve)
                .catch(reject);
        });
    }

    get_main_page_Banners() {
        return new Promise((resolve, reject) => {
            this._axios.get("mainPageBanners").then(resolve).catch(reject);
        });
    }

    get_all_categories() {
        return new Promise((resolve, reject) => {
            this._axios.get("categories").then(resolve).catch(reject);
        });
    }

    get_all_stories() {
        return new Promise((resolve, reject) => {
            this._axios.get("stories").then(resolve).catch(reject);
        });
    }

    get_all_tiles() {
        return new Promise((resolve, reject) => {
            this._axios.get("tiles").then(resolve).catch(reject);
        });
    }

    save_tiles(tiles) {
        return new Promise((resolve, reject) => {
            this._axios.post("tiles", tiles).then(resolve).catch(reject);
        });
    }

    save_category(cat) {
        return new Promise((resolve, reject) => {
            this._axios.put("categories", cat).then(resolve).catch(reject);
        });
    }

    get_filtered_data(
        type /*items/orders/users/tickets*/,
        query = null,
        sort = null,
        count = null,
        reverseSort = false,
        page = null
    ) {
        query = query || {};
        sort && (query.sort = sort);
        count && (query.count = count);
        reverseSort && (query.reverseSort = reverseSort);
        page && (query.page = page);

        let queryString = "?";
        let queryKeys = query && Object.keys(query);

        if (query && queryKeys.length > 0) {
            queryKeys.forEach((key, index) => {
                queryString += `${key}=${query[key]}${
                    index != queryKeys.length - 1 ? "&" : ""
                }`;
            });
        }

        return new Promise((resolve, reject) => {
            this._axios
                .get(`/${type}${queryString}`)
                .then(resolve)
                .catch(reject);
        });
    }

    print_not_printed_orders() {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/orders/print_not_printed")
                .then(resolve)
                .catch(reject);
        });
    }

    delet_order(id, freeUp = true) {
        return new Promise((resolve, reject) => {
            this._axios
                .delete("/orders/" + id + "?freeUp=" + freeUp)
                .then(resolve)
                .catch(reject);
        });
    }

    get_cities() {
        return new Promise((resolve, reject) => {
            this._axios.get("/post/get_cities").then(resolve).catch(reject);
        });
    }

    get_offline_payment_methods() {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/offlinePaymentMethods")
                .then(resolve)
                .catch(reject);
        });
    }

    update_order_status(order, tracking_code) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch(`/orders/update/${order}/${tracking_code || "*"}`)
                .then(resolve)
                .catch(reject);
        });
    }

    log_out() {
        return new Promise((resolve, reject) => {
            this._axios.get("/logout").then(resolve).catch(reject);
        });
    }

    upload(files, callback) {
        return new Promise((resolve, reject) => {
            if (files.length === 0) {
                resolve([]);
                return;
            }
            let results = [];
            let requests = [];
            files.forEach((file) => {
                let form = new FormData();
                form.append("file", file);
                requests.push(
                    this._axios
                        .put("/files", form)
                        .then((result) => {
                            results.push(result.data);
                            callback && callback(results, requests);
                            if (results.length === files.length)
                                resolve(results);
                        })
                        .catch(reject)
                );
            });
        });
    }

    append_message_to_ticket(ticket_id, message) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/tickets/" + ticket_id + "/new_message", message)
                .then(resolve)
                .catch(reject);
        });
    }

    delete_comment(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .delete("/comments/" + id)
                .then(resolve)
                .catch(reject);
        });
    }

    confirm_comment(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/comments/confirm/" + id)
                .then(resolve)
                .catch(reject);
        });
    }

    deleteItem(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .delete("/items/" + id)
                .then(resolve)
                .catch(reject);
        });
    }

    getAllCategories() {
        return new Promise((resolve, reject) => {
            this._axios.get("/categories").then(resolve).catch(reject);
        });
    }

    addNewItem(item) {
        return new Promise((resolve, reject) => {
            this._axios.put("/items", item).then(resolve).catch(reject);
        });
    }

    updateItem(item) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/items/" + item.id, item)
                .then(resolve)
                .catch(reject);
        });
    }

    send_coupon(coupon) {
        return new Promise((resolve, reject) => {
            this._axios.put("/coupons/", coupon).then(resolve).catch(reject);
        });
    }

    toggle_coupon_active(code) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/coupons/" + code + "/toggle_active")
                .then(resolve)
                .catch(reject);
        });
    }

    update_coupon(coupon) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/coupons/" + encodeURIComponent(coupon.code), coupon)
                .then(resolve)
                .catch(reject);
        });
    }

    delete_coupon(code) {
        return new Promise((resolve, reject) => {
            this._axios
                .delete("/coupons/" + encodeURIComponent(code))
                .then(resolve)
                .catch(reject);
        });
    }

    get_all_settings() {
        return new Promise((resolve, reject) => {
            this._axios.get("/all_settings/").then(resolve).catch(reject);
        });
    }

    save_settings(settings) {
        return new Promise((resolve, reject) => {
            this._axios
                .post("/settings/", settings)
                .then(resolve)
                .catch(reject);
        });
    }

    get_contact_info() {
        return new Promise((resolve, reject) => {
            this._axios.get("/contactInfo").then(resolve).catch(reject);
        });
    }

    deleteCategory(name) {
        return new Promise((resolve, reject) => {
            this._axios
                .delete(`/categories/${encodeURIComponent(name)}`)
                .then(resolve)
                .catch(reject);
        });
    }

    save_new_categories_arrange(stories) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/categories/re-arrange", stories)
                .then(resolve)
                .catch(reject);
        });
    }

    verify_online_payment(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/orders/verify_online_payment/" + id)
                .then(resolve)
                .catch(reject);
        });
    }

    add_story(story) {
        return new Promise((resolve, reject) => {
            this._axios.put("/stories", story).then(resolve).catch(reject);
        });
    }

    edit_story(story) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/stories/" + story.id, story)
                .then(resolve)
                .catch(reject);
        });
    }

    save_new_stories_arrange(stories) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/stories/re-arrange", stories)
                .then(resolve)
                .catch(reject);
        });
    }

    delete_story(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .delete("/stories/" + id)
                .then(resolve)
                .catch(reject);
        });
    }
}

export default Connection;
